
define(
	'TavanoTeam.IndependentDealersForm.IndependentDealersForm'
,   [
		'TavanoTeam.IndependentDealersForm.Router'
	]
,   function (
		Router
	)
{
	'use strict';

	return  {
		Router: Router,
		mountToApp: function mountToApp (Application)
		{
			return new Router({
                application: Application
            });			
		}
	};
});
